<template>
    <nav v-bind:class="{ mobile: mobile }">
        <a v-on:click="logo_ga" href="http://refinery29.com" target="_blank">
            <img id="nav_logo" src="../assets/img/refinery29_logo.svg" />
        </a>
        <div id="nav_social">
            <a v-on:click="nav_facebook_ga" href="https://www.facebook.com/refinery29" target="_blank">
                <svg class="nav_social_icon facebook" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"><title>Facebook Logo</title><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><ellipse stroke="#E8BDC0" cx="16.875" cy="17" rx="16.875" ry="17"/><path d="M15.169 24.933V17H13.5v-2.734h1.669v-1.641c0-2.23.942-3.557 3.62-3.557h2.228v2.735h-1.393c-1.042 0-1.11.382-1.11 1.095l-.006 1.368h2.525L20.737 17h-2.229v7.934H15.17z" fill="#E8BDC0"/></g></svg>
            </a>
            <a v-on:click="nav_twitter_ga" href="https://twitter.com/Refinery29" target="_blank">
                <svg class="nav_social_icon twitter" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"><title>Twitter Logo</title><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><ellipse stroke="#E8BDC0" cx="16.875" cy="17" rx="16.875" ry="17"/><path d="M25.41 10.462c-.67.41-1.41.707-2.2.866a3.404 3.404 0 0 0-2.527-1.128c-1.91 0-3.461 1.601-3.461 3.576 0 .28.03.553.09.815-2.878-.15-5.429-1.572-7.137-3.738a3.662 3.662 0 0 0-.469 1.8c0 1.24.611 2.335 1.54 2.976a3.38 3.38 0 0 1-1.569-.446v.044c0 1.733 1.194 3.18 2.779 3.507a3.35 3.35 0 0 1-1.564.063c.44 1.42 1.718 2.454 3.234 2.482A6.806 6.806 0 0 1 9 22.76a9.587 9.587 0 0 0 5.307 1.606c6.369 0 9.85-5.449 9.85-10.175 0-.156-.002-.311-.008-.464a7.134 7.134 0 0 0 1.726-1.85 6.742 6.742 0 0 1-1.988.562 3.566 3.566 0 0 0 1.523-1.978" fill="#E8BDC0"/></g></svg>
            </a>
        </div>
    </nav>
</template>

<script>
    export default {
      name: 'main-nav',
	  props: ['mobile'],
      methods: {
          nav_facebook_ga: function() {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'facebook', 'header');
              let url = 'http://refinery29.com/things-to-do-summer-2017/';
              window.open('https://www.facebook.com/dialog/share?app_id=1592779707413374&mobile_iframe=true&href=' + url, '_blank', 'left=100,top=100,width=500,height=500');
          },
          nav_twitter_ga: function() {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'twitter', 'header');
              let url = 'http://refinery29.com/things-to-do-summer-2017/';
              let text = "What's on your summer bucket list?";
              window.open('https://twitter.com/intent/tweet?text=' + text + '&url=' + url, '_blank', 'left=100,top=100,width=500,height=500');
          },
          logo_ga: function() {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'logo clicked');
          }
      }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';

    nav {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 55px;
        background-color: white;
        z-index: 1;
		transition: height 500ms;

		&.mobile {
			height: 45px;
		}
    }

    #nav_logo {
        position: absolute;
        top: 50%;
        left: 30px;
        transform: translateY(-50%);
    }

    #nav_social {
        display: flex;
        position: absolute;
        right: 30px;
        height: 100%;
        align-items: center;
    }

    .nav_social_icon {


        &.facebook {
            margin-right: 10px;
        }
    }

    @media (min-width: $small-break) {
        .nav_social_icon:hover {
            ellipse {
                fill: #E8BDC0;
                transition: fill 0.5s;
            }

            path {
                fill: white;
                transition: fill 0.5s;
            }
        }
    }


    @media (max-width: $small-break) {
        nav {
            height: 50px;
        }

        #nav_logo {
            left: 15px;
        }

        #nav_social {
            right: 15px;
        }
    }

</style>



// WEBPACK FOOTER //
// main-nav.vue?1786e269